/** 사업자등록번호를 650-86-03029 형식(3-2-5)으로 포맷. 숫자만 추출 후 최대 10자리. */
export const formatBusinessRegistrationNumber = (value: string | null | undefined): string => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};
